// import { useState } from 'react';
// import { useQuery } from '@tanstack/react-query';
import mixpanel from 'mixpanel-browser';
import { calculateRedemptionValue } from './calculateRedemptionValue';
// import { ICartItem } from '@/types/ICart';
// import { IUser } from '@/types/IUser';

// export const useSendPins = () => {
//   const { isLoading, isError, data, error } = useQuery({
//     queryKey: ['sendPins'],
//     queryFn: async () => {
//       const { data }: { data: IData } = await fetchData('https://api.example.com/sendPins');
//       return data;
//     },
//   });

//   return { isLoading, isError, data, error };
// };

// const pinText = (itemVoucher) => {
//   if (itemVoucher.length > 1) {
//     return `*PINs: ${itemVoucher.join(', ')}*`;
//   } else {
//     return `*PIN: ${itemVoucher[0]}*`;
//   }
// };

const zesaText = (voucher, zesaRecipientName, zesaRecipientAddress, electricityCurrency) =>
  `\n\nToken: ${voucher?.pin ?? '-'}, Meter number: ${voucher?.details?.meter ?? '-'}, Name: ${
    zesaRecipientName ?? '-'
  }, Address: ${zesaRecipientAddress ?? '-'}, KWH: ${voucher?.details?.kwh ?? '-'}, Energy: ${
    voucher?.details?.energy ?? '-'
  }, Debt: ${voucher?.details?.debt ?? '-'}, REA: ${voucher?.details?.rea ?? '-'}, VAT: ${
    voucher?.details?.vat ?? '-'
  }, Meter Currency: ${electricityCurrency ?? '-'}, Total amount: ${
    voucher?.details?.totalAmount ?? '-'
  }, Total amount tendered: ${voucher?.details?.totalAmountTendered ?? '-'}, Reference ID: ${
    voucher?.details?.referenceId ?? '-'
  }, Date: ${voucher?.details?.date ?? '-'}`;

export const generateMessage = (item, user, messageType) => {
  const itemVouchers = item.vouchers?.map((itemVoucher) => `*PIN: ${itemVoucher.pin}*`) || [];
  const redemptionValue = calculateRedemptionValue(item).toFixed(2);
  const recipientName = item.productRecipient?.name ?? '';
  const recipientSurname = item.productRecipient?.surname ?? '';
  const terms = item.deal.terms;
  const redemptionInstructions = item.deal.redemptionInstructions;

  // Add null checks for electricity customer data
  let zesaRecipientName = '';
  let zesaRecipientAddress = '';
  const electricityCurrency = item.productRecipient?.electricityCurrency ?? '';

  // Only try to split electricityCustomerData if it exists
  if (item.productRecipient && item.productRecipient.electricityCustomerData) {
    try {
      zesaRecipientName = item.productRecipient.electricityCustomerData.split('\n')[0] ?? '';
      zesaRecipientAddress = item.productRecipient.electricityCustomerData.split('\n')[1] ?? '';
    } catch (error) {
      console.log('Error parsing electricity customer data:', error);
    }
  }

  const termsText = terms ? ` *Terms and conditions:* ${terms}\n\n` : '';
  const redemptionInstructionsText = redemptionInstructions
    ? ` *Redemption Instructions:* ${redemptionInstructions}\n\n`
    : '';

  const deliveryText =
    item.deliveryFee && Number(item.deliveryFee) > 0
      ? `\n\nDelivery fee of $${Number(item.deliveryFee).toFixed(2)} has been received. ${
          item.deal.partnerName
        } will contact you to arrange delivery.`
      : item.deal.partnerName === 'Crossroads'
      ? `\n\nFor collection enquiries, please contact ${item.deal.partnerName} on https://wa.me/message/QP6XXOK3HUQTE1`
      : '';

  const message = `Congratulations ${recipientName} ${recipientSurname}. You have received ${
    item.quantity === 1 ? 'a ' : ''
  }digital ${messageType} voucher${item.quantity > 1 ? 's' : ''} from ${user.name || user.firstName || ''} ${
    user.surname || user.lastName || ''
  }.\n\n${item.quantity} x ${item.deal.redemptionCurrency}${redemptionValue} *${item.deal.voucherName}* from ${
    item.deal.merchantName
  }.\n\n ${item.deal.partnerName === 'ZETDC' ? '' : itemVouchers.join('\n')} \n\n${
    item.deal.partnerName === 'ZETDC'
      ? zesaText(item.vouchers[0][0], zesaRecipientName, zesaRecipientAddress, electricityCurrency)
      : deliveryText
  } ${termsText} ${redemptionInstructionsText} Terms of use available on www.lipaworld.com`.trim();

  return message;
};

export const sendMessage = (item, user, messageType, channel) => {
  mixpanel.track(`Sent ${channel} message to a recipient with ${messageType} voucher${item.quantity > 1 ? 's' : ''}`);

  if (item.productRecipient && item.redemptionInputValue) {
    const message = generateMessage(item, user, messageType);
    let shareBlock;

    if (channel === 'whatsapp') {
      shareBlock = `https://wa.me/${item.productRecipient.mobileNumber.substring(1, 20)}?text=${message}`;
    } else if (channel === 'sms') {
      shareBlock = `sms:${item.productRecipient.mobileNumber}?body=${encodeURIComponent(message)}`;
    }
    window.open(shareBlock, '_self');
  }
};

export const sendPinWhatsAppMessage = (item, user) => {
  sendMessage(item, user, 'pin', 'whatsapp');
};

export const sendTopUpWhatsAppMessage = (item, user) => {
  sendMessage(item, user, 'topup', 'whatsapp');
};

export const sendPinSmsMessage = (item, user) => {
  sendMessage(item, user, 'pin', 'sms');
};

export const sendTopUpSmsMessage = (item, user) => {
  sendMessage(item, user, 'topup', 'sms');
};

export const sendPinEmailMessage = (item, user) => {
  mixpanel.track('Sent email message to a recipient with pin voucher');
  const message = generateMessage(item, user, 'pin');
  const mailto = `mailto:?subject=You have received a voucher from ${user.name} ${
    user.surname
  }&body=${encodeURIComponent(message)}`;
  window.open(mailto, '_blank');
};

export const sendTopUpEmailMessage = (item, user) => {
  mixpanel.track('Sent email message to a recipient with topup voucher');
  const message = generateMessage(item, user, 'topup');
  const mailto = `mailto:?subject=You have received a top-up voucher from ${user.name} ${
    user.surname
  }&body=${encodeURIComponent(message)}`;
  window.open(mailto, '_blank');
};
